import React,{useContext , useEffect} from 'react';
import {  
  Card,  
  Button,
  Badge,
  Row,
  Col,
  Alert,
  ProgressBar
} from 'react-bootstrap';

import {Uploader} from '../../components';
import Utils from '../../Utils';
import StepUploadFile from './StepUploadFile';
import StepUploadVideo from './StepUploadVideo';
import StepCustomTemplate from './StepCustomTemplate';
import UserContext from './../../contexts/UserContext';
import _, { size } from 'lodash';

const Step2 = (props) => {
  const stepData = props.stepData;
  const {getPkgSize} = useContext(UserContext); 

  const onUploadVideo = (fname, file_size) => {            
    props.onUpload({...stepData, step:3, slides: [{
      sid: 1, 
      type: 'Video', 
      data:{
        mode: 'upload',
        link: Utils.apiUrl(`file?f=${fname}`), 
        vid: fname, 
        title: '',
        size: file_size, 
        description: ''
      }
    }]});
  }

  const onUploadFile = (data) => {    
    var ary = (new Array(_.get(data,'sizeArr.length',0))).fill(1);
    ary = ary.map((a,idx) => { return {sid: idx+1, type: 'Photo',size: data.sizeArr[idx].size}});
    props.onUpload({...stepData, step:3, slides: ary, fname: data.fname});
  }
  

  const onSlideSave = (templateData) => {           
    props.onUpload({...stepData, step:3, slides: [{
      sid: 1, 
      type: 'Template', 
      data:{...templateData}
    }]});
  }


  
  return <>
    <div className="heading mb-4 translate" tid="header">Let's get started! Build your course.</div>
    {stepData.mode===1 && <StepUploadFile onUpload={onUploadFile} />}
    {stepData.mode===2 && <StepUploadVideo onUpload={onUploadVideo} />}
    {stepData.mode===3 && <StepCustomTemplate onSlideSave={onSlideSave} />}
    {/* {stepData.mode===4 && <StepQuestionForm onSlideSave={onSlideSave} />} */}

  </>;
}

export default Step2;